import { cn } from '@bridebook/aura';
import { PropsWithChildren } from 'react';
import { OverAccent } from '@bridebook/web/components/wedding-website/view-mode/layouts-v2/components/over-accent';
import { UnderAccent } from '@bridebook/web/components/wedding-website/view-mode/layouts-v2/components/under-accent';

type Props = PropsWithChildren<{
  className?: string;
  underAccent?: boolean;
  overAccent?: boolean;
}>;

export const LayoutWrapper = ({
  children,
  className,
  underAccent = true,
  overAccent = true,
}: Props) => (
  <div
    className={cn(
      'relative flex w-full flex-col items-center justify-center gap-6 overflow-hidden bg-[var(--ww-palette-surface-primary)] @screen-lg:overflow-visible @screen-lg:px-[170px]',
      className,
    )}>
    {underAccent && <UnderAccent />}
    <div
      className={cn(
        'z-10 flex w-full max-w-[1100px] flex-1 flex-col items-center justify-center bg-[var(--ww-palette-surface-secondary)] transition-colors duration-300 @screen-lg:bg-[var(--ww-palette-surface-overlay)] @screen-lg:pt-10',
      )}>
      {children}
      {overAccent && <OverAccent />}
    </div>
  </div>
);
